import { render, staticRenderFns } from "./QsTab01.vue?vue&type=template&id=fbb1c65c&"
import script from "./QsTab01.vue?vue&type=script&lang=js&"
export * from "./QsTab01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports